import { render } from "./TestLandingPage.vue?vue&type=template&id=48f25ae1&scoped=true"
import script from "./TestLandingPage.vue?vue&type=script&lang=js"
export * from "./TestLandingPage.vue?vue&type=script&lang=js"

import "./TestLandingPage.vue?vue&type=style&index=0&id=48f25ae1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f25ae1"]])

export default __exports__